export default function About() {
  return (
    <>
      <div style={{ padding: "16px" }}>
        <h1>Om Sportsam.no</h1>
        <article>
          <p>
            Sportsam.no er en tjeneste som hjelper deg å sammenligne priser på
            produkter fra ulike nettbutikker innen sport og treningsutstyr. Vi
            samler produktkatalogene til en rekke produsenter og leverandører
            slik at du enkelt kan sammenligne priser og finne det beste
            tilbudet. På denne måten, får du god oversikt over produktene på
            markedet og kan enkelt finne det som passer deg og din lommebok
            best! 🎉
          </p>
          <h2>Kontakt</h2>
          <p>
            Spørsmål, ris eller ros? Send oss gjerne en e-post på{" "}
            <a href="mailto:sportsam@babymoon.no" rel="nofollow">
              sportsam@babymoon.no
            </a>
            .
          </p>
          <h2>Partnere</h2>
          <p>
            Sportsam.no reklamerer gjennom annonselenker til våre
            samarbeidspartnere.
          </p>
          <h2>Babymoon.no</h2>
          <p>
            Sportsam drives av{" "}
            <a
              href="https://babymoon.no"
              rel="nofollow"
              title="Klikk for å besøke Babymoon.no"
              target="_blank"
            >
              Babymoon.no
            </a>
            , som er en tjeneste som hjelper småbarnsforeldre å sammenligne
            priser på produkter for småbarnsforeldre.
          </p>
        </article>
      </div>
    </>
  );
}
